"use client";

import React from 'react';
import Navigation from "./navigation";
import Hero from "./hero";
import Featured from "./featured";
import Contact from "./contact";
import Footer from "./footer";
import sketchy_background from './assets/sketchy_background.svg';
import headerBg from "./assets/header_bg.jpg";
import About from "./about";


export default function LandingPage() {
    return (
        <div className="min-h-screen text-[1.5rem] md:text-xl  leading-normal  xl:py-[3rem]  xl:px-10   bg-thebackground " >
            <div className=""   style={{ backgroundImage: `url(${sketchy_background})` }}>
            {/* Navigation */}
            <Navigation />

            {/* Hero Section */}
            <Hero />


            <About />
            {/* Contact Section */}
            <Contact />

            {/* Footer */}

            <Footer />
            </div>
        </div>
    );
}